// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"3":"b9cc642d","225":"8b960d48","263":"ceacd7da","267":"56402687","284":"283ab4d8","371":"192ac9ab","387":"03b7ed6f","532":"34dd8060","675":"5a5a630c","824":"3466793b","861":"e61836e7","934":"cc7b157e"}[chunkId] + ".js";
};